export const WEBHOOK_API_VERSION = '2026-10';
export const WEBHOOK_EVENTS = [
    { name: 'visit.signed_in', module: 'visits', event: 'visits.visit.signed_in' },
    { name: 'visit.signed_out', module: 'visits', event: 'visits.visit.signed_out' },
    { name: 'visit.updated', module: 'visits', event: 'visits.visit.updated' },
    { name: 'visit.deleted', module: 'visits', event: 'visits.visit.deleted' },
    { name: 'preregistration.created', module: 'pre-registration', event: 'pre-registration.preregistration.created' },
    { name: 'preregistration.updated', module: 'pre-registration', event: 'pre-registration.preregistration.updated' },
    { name: 'preregistration.cancelled', module: 'pre-registration', event: 'pre-registration.preregistration.cancelled' },
    { name: 'preregistration.arrived', module: 'pre-registration', event: 'pre-registration.preregistration.arrived' },
    { name: 'member.created', module: 'members', event: 'members.member.created' },
    { name: 'member.updated', module: 'members', event: 'members.member.updated' },
    { name: 'member.archived', module: 'members', event: 'members.member.archived' },
    { name: 'feedback.received', module: 'feedback', event: 'feedback.response.received' },
    // Phase 3 (payload builders in each owner's manifest; shapes in its contract)
    { name: 'evacuation.started', module: 'evacuation', event: 'evacuation.evacuation.started' },
    { name: 'evacuation.ended', module: 'evacuation', event: 'evacuation.evacuation.ended' },
    { name: 'safety_check.failed', module: 'safety-check', event: 'safety-check.check.failed' },
    { name: 'delivery.logged', module: 'deliveries', event: 'deliveries.delivery.logged' },
    { name: 'delivery.collected', module: 'deliveries', event: 'deliveries.delivery.collected' },
    { name: 'permit.issued', module: 'permits', event: 'permits.permit.issued' },
    { name: 'permit.closed', module: 'permits', event: 'permits.permit.closed' },
    { name: 'lone_working.escalated', module: 'lone-working', event: 'lone-working.escalation.started' },
    { name: 'occupancy.level_changed', module: 'occupancy', event: 'occupancy.level.changed' },
    // Phase 4: lets linked systems erase their copy too (ids only, never the erased details).
    { name: 'person.erased', module: 'data-protection', event: 'data-protection.subject.erased' },
    { name: 'notification', module: 'notifications', event: null },
    { name: 'test', module: 'webhooks', event: null },
];
export const WEBHOOK_EVENT_NAMES = WEBHOOK_EVENTS.map((e) => e.name);
/** API key scopes (ADR 0019 for Phase 2; ADR 0027 for Phase 4). Labels: `apiScope.<scope>`. Never rename a released scope. */
export const API_SCOPES = [
    'visits.sign_in',
    'visits.sign_out',
    'visits.on_site',
    'webhooks.test',
    // Phase 4 (ADR 0027)
    'sites.read',
    'groups.read',
    'members.read',
    'members.write',
    'visits.read',
    'preregistrations.read',
    'preregistrations.write',
];
//# sourceMappingURL=events.js.map